import {
  Form,
  Input,
  Select,
  TimePicker,
  Checkbox,
  Button,
  Modal,
  message,
} from "antd";
import { useState, useEffect, useCallback } from "react";
import { useLocation, useParams } from "react-router-dom";
import dayjs from "dayjs";
import axios from "axios";
import { useAuth } from "../Context/AuthContext";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);



const { Option } = Select;

const WorkLogForm = ({ isModalOpen, handleOk, handleCancel }) => {
  const [form] = Form.useForm();
  const { date } = useParams();
  const [workType, setWorkType] = useState("");
  const { user } = useAuth();
  const location = useLocation();
  const firstSegment = location.pathname.split("/").filter(Boolean)[0];
  const apiUrl = process.env.REACT_APP_API_URL;
  const [auditors, setAuditors] = useState([]);

  // Fetch auditors when the modal opens
  const fetchAuditors = useCallback(() => {
    axios
      .get(`${apiUrl}/api/auth/getAllRepresentatives`)
      // .get(`${apiUrl}/api/auditor/getAuditAdmins`)
      .then((response) => {
        if (response.data.success) {
          setAuditors(response.data.data);
          // console.log(response.data.data, "auditors list");
        }
      })
      .catch((error) => console.error("Error fetching auditors:", error));
  }, []);
  // console.log(date, "date of data")
  useEffect(() => {
    if (isModalOpen && firstSegment === "admin-work-log") {
      fetchAuditors();
    }
  }, [isModalOpen, firstSegment, fetchAuditors]);

  const onFinish = async (values) => {
    // if (values.startTime && values.endTime) {
    //   if (dayjs(values.startTime).isAfter(dayjs(values.endTime))) {
    //     message.error("Start time should be less than end time");
    //     return;
    //   }
    // }
    // console.log(values, "form values on submit");

    if (values.startTime && values.endTime) {


      const selectedDate = dayjs(date, "DD-MM-YYYY", true);

      if (!selectedDate.isValid()) {
        message.error("Invalid date");
        return;
      }

      const start = selectedDate
        .hour(values.startTime.hour())
        .minute(values.startTime.minute())
        .second(0);

      const end = selectedDate
        .hour(values.endTime.hour())
        .minute(values.endTime.minute())
        .second(0);

      if (start.isAfter(end)) {
        message.error("Start time should be less than end time");
        return;
      }


      console.log(start.toISOString(), "start time");
      // 2025-12-02T04:00:00.000Z

      console.log(end.toISOString(), "end time");
      // 2025-12-02T12:30:00.000Z

      try {
        const data = {
          userId: firstSegment === "admin-work-log" ? values.userId : user._id,
          // userId: firstSegment === "admin-work-log" ? values.userId : user._id,
          workType: values.workType,
          // startTime: values.startTime
          //   ? dayjs(values.startTime).toISOString()
          //   : null,
          // endTime: values.endTime ? dayjs(values.endTime).toISOString() : null,
          startTime: start.toISOString(),
          endTime: end.toISOString(),
          date: date, // Use the date from URL params
          description: values.description || "",
          reason: values.reason || "",
          paidLeave: values.paidLeave || false,
          sickLeave: values.sickLeave || false,
        };
        console.log("Submitting Data:", data); // Debug log
        const response = await axios.post(`${apiUrl}/api/worklogs/createWorkLog`, data);

        if (response.status === 201) {
          console.log("Work log created successfully:", response.data);
          handleOk();
        }
      } catch (error) {
        console.error("Error saving work log:", error);
        const errorMsg =
          error?.message === "Network Error"
            ? "Please check the network connection"
            : "Something went wrong";

        message.error(errorMsg);

        if (error.response) {
          console.log("API Response:", error.response);

          if (error.response.status === 401) {
            message.error("Work log entry already exists for today");
            return;
          } else if (error.response.status === 400) {
            message.error("Time cannot overlap with existing work logs");
            return;
          } else if (error.response.status === 500) {
            message.error("Please check the Network Connection ");
            return;
          }
        }
      }
    }
  };



  // const onFinish = async (values) => {
  //   // keep existing validation for start/end times
  //   if (values.startTime && values.endTime) {
  //     if (dayjs(values.startTime).isAfter(dayjs(values.endTime))) {
  //       message.error("Start time should be less than end time");
  //       return;
  //     }
  //   }

  //   try {
  //     // Build payload in the exact structure you requested.
  //     // Use today's date automatically (Asia/Kolkata assumed) in DD-MM-YYYY format.
  //     const todayDate = dayjs().format("DD-MM-YYYY"); // -> "29-10-2025"

  //     const formatTime = (t) =>
  //       t ? dayjs(t).format("HH:mm A") : null; // -> "20:00 PM" (matches your example "20:00 pm")

  //     const data = {
  //       userId: firstSegment === "admin-work-log" ? values.userId : user._id,
  //       workType: values.workType,
  //       startTime: formatTime(values.startTime), // "20:00 PM" or null
  //       endTime: formatTime(values.endTime), // "22:00 PM" or null
  //       date: todayDate, // "29-10-2025"
  //       description: values.description || "",
  //       reason: values.reason || "",
  //       paidLeave: !!values.paidLeave,
  //       sickLeave: !!values.sickLeave,
  //     };

  //     console.log("Submitting Data:", data); // debug

  //     const response = await axios.post(
  //       `${apiUrl}/api/worklogs/createWorkLog`,
  //       data
  //     );

  //     if (response.status === 201) {
  //       console.log("Work log created successfully:", response.data);
  //       handleOk();
  //     }
  //   } catch (error) {
  //     console.error("Error saving work log:", error);

  //     if (error.response) {
  //       console.log("API Response:", error.response);

  //       if (error.response.status === 401) {
  //         message.error("Work log entry already exists for today");
  //         return;
  //       } else if (error.response.status === 400) {
  //         message.error("Time cannot overlap with existing work logs");
  //         return;
  //       }
  //     }
  //   }
  // };

  return (
    <Modal
      title="Work Log Form"
      open={isModalOpen}
      onOk={handleOk}
      onCancel={() => {
        form.resetFields(); // Reset form fields
        handleCancel(); // Call parent function to close modal and fetch data
      }}
      footer={null}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={{ paidLeave: false, sickLeave: false }}
        onFinish={onFinish}
      >
        {/* Show "Select User" only if firstSegment is "admin-work-log" */}
        {firstSegment === "admin-work-log" && (
          <Form.Item
            name="userId"
            label="Select Auditor"
            rules={[{ required: true }]}
          >
            <Select placeholder="Select User">
              {auditors.map((auditor) => (
                <Option key={auditor._id} value={auditor._id}>
                  {auditor.userName}
                </Option>
              ))}
            </Select>
          </Form.Item>
        )}

        <Form.Item
          name="workType"
          label="Work Type"
          rules={[{ required: true }]}
        >
          <Select
            placeholder="Select Work Type"
            onChange={(value) => setWorkType(value)}
          >
            <Option value="audit">Audit Work</Option>
            <Option value="wfh">WFH</Option>
            <Option value="office">Office</Option>
            <Option value="onDuty">On Duty</Option>
            {/* <Option value="absent">Absent</Option> */}
          </Select>
        </Form.Item>

        <div className="grid grid-cols-2 gap-4">
          <Form.Item
            name="startTime"
            label="Start Time"
            // rules={[{ required: workType !== "absent" }]}
            rules={[{ required: true }]}
          >
            <TimePicker
              use12Hours
              format="h:mm A"
              className="w-full"
              disabled={workType === "absent"}
            />
          </Form.Item>
          <Form.Item
            name="endTime"
            label="End Time"
            // rules={[{ required: workType !== "absent" }]}
            rules={[{ required: true }]}
          >
            <TimePicker
              use12Hours
              format="h:mm A"
              className="w-full"
              disabled={workType === "absent"}
            />
          </Form.Item>
        </div>

        <Form.Item name="description" label="Description" rules={[{ required: true }]}>
          <Input.TextArea
            rows={3}
            placeholder="Enter description"
            disabled={workType === "absent"}
          />
        </Form.Item>

        {workType === "absent" && (
          <>
            <Form.Item
              name="reason"
              label="Reason"
              rules={[{ required: true }]}
            >
              <Input.TextArea rows={2} placeholder="Enter reason for absence" />
            </Form.Item>

            <div className="flex gap-4">
              <Form.Item name="paidLeave" valuePropName="checked">
                <Checkbox>Paid Leave</Checkbox>
              </Form.Item>
              <Form.Item name="sickLeave" valuePropName="checked">
                <Checkbox>Sick Leave</Checkbox>
              </Form.Item>
            </div>
          </>
        )}

        <Form.Item>
          <Button type="primary" htmlType="submit" className="w-full">
            Submit
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default WorkLogForm;
